import type { LanguageCode } from "config/languages";

export const getParentLanguage = (language: LanguageCode) => language.split("-")[0] as LanguageCode;
